//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import "@/mixins/global";
import chartOTP from "../components/chartOTP";
import axios, { CancelToken } from "axios";
import ChartOTP from "../components/chartOTP.vue";
export default {
  components: {
    chartOTP,
  },
  data() {
    return {
      chartTRMDoc: {
        ALL: [],
        TLA31: [],
        TLA32: [],
        TLA41: [],
      },
      chartTRMSample: {
        ALL: [],
        TLA31: [],
        TLA32: [],
        TLA41: [],
      },

      ps: "202040",
      pe: "202052",
      apinonnike_doc:`${this.$apiFix}OTP_NONNIKE.php/trm_doc`,
        // "http://localhost:9000/nygcontrolroom/OTP_NONNIKE.php/trm_doc",
      apinonnike_sample:`${this.$apiFix}OTP_NONNIKE.php/trm_sample`,
        // "http://localhost:9000/nygcontrolroom/OTP_NONNIKE.php/trm_sample",
    };
  },
  async mounted() {
    this.nonnikeDoc();
    this.nonnikeSample();
  },
  methods: {
    goPage(routerName) {
      this.$router.push({
        name: routerName,
      });
    },

    nonnikeDoc() {
      axios
        .get(`${this.apinonnike_doc}?ps=${this.ps}&pe=${this.pe}&team=`)
        .then((response) => {
          this.chartTRMDoc.ALL = response.data;
        });
      axios
        .get(`${this.apinonnike_doc}?ps=${this.ps}&pe=${this.pe}&team=TLA3-1`)
        .then((response) => {
          this.chartTRMDoc.TLA31 = response.data;
        });
      axios
        .get(`${this.apinonnike_doc}?ps=${this.ps}&pe=${this.pe}&team=TLA3-2`)
        .then((response) => {
          this.chartTRMDoc.TLA32 = response.data;
        });
      axios
        .get(`${this.apinonnike_doc}?ps=${this.ps}&pe=${this.pe}&team=TLA4-1`)
        .then((response) => {
          this.chartTRMDoc.TLA41 = response.data;
        });
     
    },
    nonnikeSample() {
      axios
        .get(`${this.apinonnike_sample}?ps=${this.ps}&pe=${this.pe}&team=`)
        .then((response) => {
          this.chartTRMSample.ALL = response.data;
        });
      axios
        .get(`${this.apinonnike_sample}?ps=${this.ps}&pe=${this.pe}&team=TLA3-1`)
        .then((response) => {
          this.chartTRMSample.TLA31 = response.data;
        });
      axios
        .get(`${this.apinonnike_sample}?ps=${this.ps}&pe=${this.pe}&team=TLA3-2`)
        .then((response) => {
          this.chartTRMSample.TLA32 = response.data;
        });
      axios
        .get(`${this.apinonnike_sample}?ps=${this.ps}&pe=${this.pe}&team=TLA4-1`)
        .then((response) => {
          this.chartTRMSample.TLA41 = response.data;
        });
      
    },
  },
};
